
define('text!modules/my-organization/states/my-organization/template.html',[],function () { return '<div class="lls-row u-paddingHorizontalLarge"><div class=lls-col-xs-12><div class=c-card__flat><my-organization-tabs></my-organization-tabs></div></div></div>';});

